import axios from "axios";

export * from "./routes.constants";

//export const baseURL = "https://test.api.therapeacezone.com.ng/api/v1";
export const baseURL = "https://live.api.therapeacezone.com.ng/api/v1";

const axiosInstance = axios.create({
  baseURL,
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json ",
    "Access-Control-Allow-Headers": "Content-Type",
  },
});

const addTokenToRequest = async (req) => {
  const token = localStorage.getItem("11p221#");
  req.headers.Authorization = `Bearer ${token}`;
  return req;
};

axiosInstance.interceptors.request.use(addTokenToRequest);

export default axiosInstance;
